<script setup lang="ts">
import { Color } from '@previo/codebooks'
import PIcon from '../../../../icon/PIcon.vue'
import PTextHighlighted from '../../../../typography/body/PTextHighlighted.vue'
import YearNavigation from './YearNavigation.vue'
import MonthNavigation from './MonthNavigation.vue'

type Props = {
  text: string | number
  value: number
  navigationComponent?: InstanceType<typeof YearNavigation> | InstanceType<typeof MonthNavigation>
  offset?: number
}

const props = defineProps<Props>()

const onClick = (): void => {
  if (props.offset) {
    return props.navigationComponent?.toggle(props.value, props.offset)
  }

  props.navigationComponent?.toggle(props.value)
}
</script>

<template>
  <div class="p-cursor-pointer p-flex p-items-center" @click="onClick">
    <p-text-highlighted :text="text" />
    <p-icon :color="Color.PRIMARY_DARK" icon="chevron-down" cursor-pointer />
  </div>
</template>
